/** Egyptian mobile number normalisation (the UI always shows +20 beside the field). */

/** Local numbers are 10 digits once the country and trunk prefixes are removed. */
export const PHONE_DIGITS = 10;

/**
 * Reduce anything the customer types or pastes to the bare local number.
 *
 * Egyptian mobiles are written `01X XXXX XXXX`, but the field already supplies
 * the +20 country code, so the leading trunk `0` must come off — otherwise it
 * eats a slot and the last digit is truncated away (`01012345678` → `0101234567`).
 * Pasted international forms (`+20…`, `0020…`) are reduced the same way.
 */
export function normalizeEgPhone(raw: string): string {
  return raw
    .replace(/\D/g, '')          // digits only
    .replace(/^(?:00)?20/, '')   // pasted country code
    .replace(/^0+/, '')          // national trunk prefix: 012… → 12…
    .slice(0, PHONE_DIGITS);
}

/** A local number is complete only at exactly 10 digits — no shorter. */
export function isValidEgPhone(raw: string): boolean {
  return normalizeEgPhone(raw).length === PHONE_DIGITS;
}
